import React from 'react';
import { SourceFunnel } from '../types';
import SourcesList from './SourcesList';

/** The Engagement page's sources — one row per arrival source, counted by
 *  person, grouped by channel. Row click filters the page to that source. */
const SourcesCard: React.FC<{
  sources: SourceFunnel[];
  /** The tag the page is filtered to; its row is highlighted. */
  activeTag?: string | null;
  /** Row click filters the page to that source (click again to clear). */
  onSelect?: (tag: string | null) => void;
}> = ({ sources, activeTag = null, onSelect }) => (
  <SourcesList
    title="Sources"
    note="counted by person · click a source to filter"
    rows={sources}
    people={(s) => s.people}
    peopleHeader="People"
    tapped={(s) => s.cta_clicked}
    selected={activeTag}
    onSelect={onSelect && ((r) => onSelect(r?.tag ?? null))}
  />
);

export default SourcesCard;
